import { render, staticRenderFns } from "./topMenu.vue?vue&type=template&id=2a5fc696&scoped=true"
import script from "./topMenu.vue?vue&type=script&lang=js"
export * from "./topMenu.vue?vue&type=script&lang=js"
import style0 from "./topMenu.vue?vue&type=style&index=0&id=2a5fc696&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5fc696",
  null
  
)

export default component.exports